<template>
  <div class="w-full flex">
    <aside class="hidden bg-grey-30 lg:block min-w-[232px] px-4">
      @TODO
    </aside>
    <main class="p-8 lg:py-10 lg:px-20 shrink">
      <slot />
    </main>
  </div>
  <footer class="w-full">FOOTER</footer>
</template>

<script setup lang="ts">
</script>